import { CSS, StyleProps } from "@shared/primitive-components"
import { getBackgroundColor, getTextColor } from "./severity"

export const getScoreStyle = (value: number | null) => (props: StyleProps) => ({
  ...props.theme.fonts.heading,
  width: `32px`,
  height: `27px`,
  color: getTextColor(value, props),
  backgroundColor: getBackgroundColor(value, props),
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`,
})

const getScoreChangeTextColor = (change: number | null, props: StyleProps) => {
  if (change === null) return props.theme.palette.grey.dark
  if (change > 0) return props.theme.palette.full.green
  if (change < 0) return props.theme.palette.full.red
  return props.theme.palette.grey.dark
}

export const getScoreChangeStyle = (change: number | null) => (props: StyleProps) => ({
  ...props.theme.fonts.heading,
  width: `32px`,
  height: `27px`,
  color: getScoreChangeTextColor(change, props),
  backgroundColor: props.theme.palette.white,
  borderTop: `1px solid ${props.theme.palette.grey.dark}`,
  borderRight: `1px solid ${props.theme.palette.grey.dark}`,
  borderBottom: `1px solid ${props.theme.palette.grey.dark}`,
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`,
})

const worstScoringSharedContainerStyle = (flex: number, props: StyleProps): CSS => ({
  flex,
  padding: props.theme.spacing(6),
  backgroundColor: props.theme.palette.white,
})

export const worstScoringVehiclesContainer = (props: StyleProps): CSS => ({
  ...worstScoringSharedContainerStyle(4, props),
  minHeight: `421px`,
})

export const worstScoringTripsContainer = (props: StyleProps): CSS => ({
  ...worstScoringSharedContainerStyle(8, props),
})

export const tooltip = (): CSS => ({
  maxWidth: `200px`,
})
